





import Vue from 'vue';

export default Vue.extend({
  props: {
    lang: { type: String, default: undefined },
    dark: { type: Boolean, default: false },
  },
  data: () => ({
    isReady: false,
    renderedCode: '',
    hljs: undefined as any,
  }),
  computed: {
    codeStyle(): Record<string, string> {
      return {
        'background-color': this.dark ? '#21262d' : '#fefefe',
        color: this.dark ? '#fefefe' : '#21262d',
      };
    },
  },
  beforeUpdate() {
    if (this.isReady) {
      this.$debounce(() => {
        this.performHighlighting();
      }, 500, this)();
    }
  },
  async mounted() {
    try {
      // Lazyload since this is only used rarely, this way it won't bloat normal apps
      import('highlight.js').then((module) => {
        this.isReady = true;
        this.hljs = module.default;
        this.performHighlighting();
      });
      if (this.dark) {
        // @ts-ignore
        import('highlight.js/styles/github-dark.css');
      } else {
        // @ts-ignore
        import('highlight.js/styles/github.css');
      }
    } catch (error: any) {
      this.$log.error('Unable to highlight code:');
      this.$log.error(error);
    }
  },
  methods: {
    performHighlighting() {
      if (this.isReady) {
        const defaultSlot = this._.component.getSlot(this, 'default');
        if (defaultSlot) {
          if (this.lang) {
            const parseResult = this.hljs.highlight(defaultSlot.text?.trim(), { language: this.lang });
            this.renderedCode = parseResult.value;
          } else {
            const parseResult = this.hljs.highlightAuto(defaultSlot.text?.trim());
            this.renderedCode = parseResult.value;
          }
        }
      } else {
        this.$log.error('Unable to highlight code, component not ready yet');
      }
    },
  },
});
